
import axios from 'axios'

//const BASE_URL = 'http://cerberusc.camtor.net:5005'
const BASE_URL = process.env.REACT_APP_SERVER_URL;
const axiosInstance = axios.create({
    baseURL: BASE_URL,
})




export async function crudDispositivosApi({ comando, token = '', data = null }) {

    //console.log('crudDispositivosApi: ', { comando, token, data });

    const headers = token ? { 'content-type': 'application/json', authorization: `Bearer ${token}` }
        : { 'content-type': 'application/json' }

    const body = { comando, token, data };

    try {
        const response = await axiosInstance.post('/dev/api', body, {   //devices api
            headers: headers
        })
        //console.log("response.data", response.data);
        return response.data;
    } catch (error) {
        //console.log(error);
        //console.log(error.response.data.message);
        throw new Error(error.response.data.message);
    }
}

export async function deleteDispositivo(id) {
    const response = await fetch(`${BASE_URL}/songs/${id}`, {
        method: 'DELETE',
    })
    return response.json()
}